import React, { useState, forwardRef, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import useAuthContext from "../../../../hooks/useAuthContext";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import paymentsAPI from "../../../../services/payments";
import uiDataAPI from "../../../../services/ui_data";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";

const UpdateContractPaymentModal = forwardRef((props, ref) => {
    //
    const schoolId = props?.schoolId;
    const trainingId = props?.trainingId;
    const accessToken = "";
    //
    const [id, setId] = useState("");
    const [method, setMethod] = useState("");
    const [amount, setAmount] = useState("0");
    const [status, setStatus] = useState("");
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [paymentReceivedDate, setPaymentReceivedDate] = useState(new Date());
    const [details, setDetails] = useState("");
    const [helloassoPaymentId, setHelloassoPaymentId] = useState("");
    const [helloassoOrderId, setHelloassoOrderId] = useState("");
    const [helloassoInstallmentNumber, setHelloassoInstallmentNumber] = useState(1);
    const [helloassoPaymentReceiptUrl, setHelloassoPaymentReceiptUrl] = useState("");
    //
    const UiDataPaymentMethodTypesListQuery = uiDataAPI.UiDataPaymentMethodTypesList(
        accessToken
    );
    const UiDataPaymentStatusTypesListQuery = uiDataAPI.UiDataPaymentStatusTypesList(
        accessToken
    );

    useEffect(() => {
        setId(props?.payment?.id);
        setAmount(props?.payment?.amount);
        setMethod(props?.payment?.method);
        setStatus(props?.payment?.status);
        setPaymentDate(props?.payment?.payment_date ? new Date(props?.payment?.payment_date) : new Date());
        setPaymentReceivedDate(props?.payment?.payment_received_date ? new Date(props?.payment?.payment_received_date) : new Date());
        setDetails(props?.payment?.details);
        setHelloassoPaymentId(props?.payment?.helloasso_payment_id || "");
        setHelloassoOrderId(props?.payment?.helloasso_order_id || "");
        setHelloassoInstallmentNumber(props?.payment?.helloasso_installment_number != null ? props.payment.helloasso_installment_number : 1);
        setHelloassoPaymentReceiptUrl(props?.payment?.helloasso_payment_receipt_url || "");
    }, [props]);

    const paymentStatusOptions = UiDataPaymentStatusTypesListQuery?.data?.data || [];
    const selectablePaymentStatusOptions = (() => {
        const allStatuses = paymentStatusOptions;
        let filtered = allStatuses;
        if (method === "CHEQUE" || method === "OTHER") {
            filtered = allStatuses.filter(option => option?.id === "PAID" || option?.id === "PENDING");
        } else if (method === "CB" || method === "CASH") {
            filtered = allStatuses.filter(option => option?.id === "PAID");
        }
        
        // Ensure current status is always selectable to avoid UI bugs if it has a legacy/unexpected status
        if (status && !filtered.some(option => option.id === status)) {
            const currentOption = allStatuses.find(option => option.id === status);
            if (currentOption) {
                filtered = [...filtered, currentOption];
            }
        }
        return filtered;
    })();




    const paymentDateLabel = status === "PAID"
        ? "Date d'encaissement"
        : status === "PENDING"
            ? "Date d'encaissement prévue"
            : "Date d'encaissement";

    return (
        <>
            <MeaUpdateModal
                ref={ref}
                title="Modifier un paiement"
                serviceAPI={paymentsAPI}
                id={id}
                schoolId={schoolId}
                trainingId={trainingId}
                data={{
                    amount: amount,
                    method: method,
                    status: status,
                    payment_date: (() => {
                        // Set paymentDate to mid-day of the chosen date
                        const currentDate = paymentDate || new Date();
                        const middayDate = new Date(currentDate);
                        middayDate.setHours(12, 0, 0, 0);
                        return middayDate;
                    })(),
                    payment_received_date: (() => {
                        // Set paymentReceivedDate to mid-day of the chosen date
                        const currentDate = paymentReceivedDate || new Date();
                        const middayDate = new Date(currentDate);
                        middayDate.setHours(12, 0, 0, 0);
                        return middayDate;
                    })(),
                    payment_refund_date: null,
                    details: details,
                    helloasso_payment_id: method === "HELLOASSO" ? (helloassoPaymentId || null) : null,
                    helloasso_order_id: method === "HELLOASSO" ? (helloassoOrderId || null) : null,
                    helloasso_installment_number: method === "HELLOASSO" ? helloassoInstallmentNumber : null,
                    helloasso_payment_receipt_url: method === "HELLOASSO" ? (helloassoPaymentReceiptUrl || null) : null,
                }}
            >
                <label htmlFor="method" className="block text-900 font-medium mb-2">
                    Méthode de paiement
                </label>
                <Dropdown
                    id="method"
                    value={UiDataPaymentMethodTypesListQuery?.data?.data?.find(
                        (obj) => obj.id === method
                    )}
                    options={UiDataPaymentMethodTypesListQuery?.data?.data}
                    onChange={(e) => setMethod(e.value?.id)}
                    optionLabel="name"
                    disabled
                    placeholder="Sélectionner une méthode"
                    checkmark={true}
                />
                <label
                    htmlFor="amount"
                    className="block text-900 font-medium mb-2"
                >
                    Montant
                </label>
                <InputNumber
                    id="amount"
                    value={amount}
                    showButtons
                    min={0}
                    onValueChange={(e) => setAmount(e.value)}
                    rows={3}
                    className="w-full mb-3"
                />
                <label htmlFor="name" className="block text-900 font-medium mb-2">
                    Status
                </label>
                <Dropdown
                    id="status"
                    value={selectablePaymentStatusOptions?.find(
                        (obj) => obj.id === status
                    )}
                    options={selectablePaymentStatusOptions}
                    onChange={(e) => setStatus(e.value?.id)}
                    optionLabel="name"
                    placeholder="Sélectionner un status"
                    className="mb-3"
                    checkmark={true}
                />

                <label
                    htmlFor="paymentReceivedDate"
                    className="block text-900 font-medium mb-2"
                >
                    Date de réception
                </label>
                <Calendar
                    id="paymentReceivedDate"
                    value={paymentReceivedDate}
                    onChange={(e) => setPaymentReceivedDate(e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                    className="w-full mb-3"
                />

                <label
                    htmlFor="paymentDate"
                    className="block text-900 font-medium mb-2"
                >
                    {paymentDateLabel}
                </label>
                <Calendar
                    id="paymentDate"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                    className="w-full mb-3"
                />

                {method === "HELLOASSO" && (
                    <>
                        <label htmlFor="helloassoPaymentId" className="block text-900 font-medium mb-2">
                            N° de paiement HelloAsso
                        </label>
                        <InputText
                            id="helloassoPaymentId"
                            value={helloassoPaymentId}
                            onChange={(e) => setHelloassoPaymentId(e.target.value)}
                            className="w-full mb-3"
                        />

                        <label htmlFor="helloassoOrderId" className="block text-900 font-medium mb-2">
                            N° d'ordre HelloAsso
                        </label>
                        <InputText
                            id="helloassoOrderId"
                            value={helloassoOrderId}
                            onChange={(e) => setHelloassoOrderId(e.target.value)}
                            className="w-full mb-3"
                        />

                        <label htmlFor="helloassoInstallmentNumber" className="block text-900 font-medium mb-2">
                            N° d'échéance HelloAsso
                        </label>
                        <InputNumber
                            id="helloassoInstallmentNumber"
                            value={helloassoInstallmentNumber}
                            onValueChange={(e) => setHelloassoInstallmentNumber(e.value || 1)}
                            showButtons
                            min={1}
                            className="w-full mb-3"
                        />

                        <label htmlFor="helloassoPaymentReceiptUrl" className="block text-900 font-medium mb-2">
                            Attestation de paiement HelloAsso (URL)
                        </label>
                        <InputText
                            id="helloassoPaymentReceiptUrl"
                            value={helloassoPaymentReceiptUrl}
                            onChange={(e) => setHelloassoPaymentReceiptUrl(e.target.value)}
                            className="w-full mb-3"
                        />
                    </>
                )}

                <label
                    htmlFor="details"
                    className="block text-900 font-medium mb-2"
                >
                    Détails
                </label>
                <InputTextarea
                    id="details"
                    type="text"
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    rows={3}
                    className="w-full mb-3"
                />
            </MeaUpdateModal >
        </>
    );
});

export default UpdateContractPaymentModal;
